import {sendRequest, replaceModal} from "./components/replaceModal.js";

let ModalSMSAuth = {
    buttonActive: true,
    modalName: "sms-auth",
    modalButtonOpenId: "js-mindbox-sms-auth",
    userPhoneFieldId: "userfield_personal_phone",
    userPhone: "",
    /**
     * Инициализация скриптов.
     * Навешивание обработчиков событий,
     * получение введённого пользователем телефона, отправка запроса
     */
    init: function () {
        "use strict";

        const modalOpenButton = document.getElementById(ModalSMSAuth.modalButtonOpenId);

        modalOpenButton.addEventListener("click", () => {
            if (ModalSMSAuth.buttonActive !== false) {
                let url = modalOpenButton.dataset.dist;
                let $userPhoneInput = document.getElementById(ModalSMSAuth.userPhoneFieldId);
                if (!!$userPhoneInput) {
                    ModalSMSAuth.userPhone = $userPhoneInput.value;
                }
                let params = {
                    "USER_PHONE": ModalSMSAuth.userPhone
                };
                sendRequest({
                    url: url,
                    data: params,
                    method: "POST",
                    success: function (res) {
                        if (res.length > 0) {
                            replaceModal(res, ModalSMSAuth.modalName, () => {
                                ModalSMSAuth.buttonActive = false;
                            });
                            ModalSMSAuth.buttonActive = false;
                        } else {
                            ModalSMSAuth.buttonActive = true;
                        }
                    }
                });
            }
        });
    }
}

export {
    ModalSMSAuth
}